export default function DemoSection() {
  return (
    <section id="demo" className="py-10 bg-muted/30">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-5xl font-bold text-balance mb-4">{"Decision-ready insights in seconds"}</h2>
          <p className="text-lg text-muted-foreground text-balance max-w-2xl mx-auto">
            {
              "What used to take hours of manual cross-referencing now happens instantly with AI-powered intelligence."
            }
          </p>
        </div>

        <div className="max-w-6xl mx-auto">
          <div className="relative w-full aspect-video py-10">
            <iframe
              src="https://app.supademo.com/embed/cmmwro1190tirepohcs2qxjro?embed_v=2&utm_source=embed"
              loading="lazy"
              title="Kanu Energy"
              allow="clipboard-write"
              allowFullScreen
              className="absolute inset-0 w-full h-full"
            />
          </div>
        </div>
      </div>
    </section>
  )
}
